import { FC, PropsWithChildren } from "react"
import { TonConnectUIProvider } from "@tonconnect/ui-react"

export const TonConnectProvider: FC<PropsWithChildren> = ({ children }) => {
  return (
    <TonConnectUIProvider
      manifestUrl={`${import.meta.env.VITE_MANIFEST_URL}`}
      actionsConfiguration={{
        twaReturnUrl: `https://t.me/${import.meta.env.VITE_BOTNAME}/${import.meta.env.VITE_WEBAPP_NAME}`
      }}
    >
      {children}
    </TonConnectUIProvider>
  )
}
